import { AdminPanelSpeakers } from './AdminPanelSpeakers';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const mapStateToProps = () => ({});

export default withRouter(connect(
    mapStateToProps,
    {}
)(AdminPanelSpeakers));